import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';


const FIELDS = {
    // accountNumber: {
    //     type: "input",
    //     label: "Bank Account Number",
    //     isRequired: true,
    //     hide : true,
    //     validations: {
    //         presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
    //         length: {
    //             minimum: 9,
    //             maximum: 20
    //         }
    //     }
    // },
    // ifscCode: {
    //     type: "input",
    //     label: "IFSC Code",
    //     isRequired: true,
    //     toUpperCase: true,
    //     hide : true,
    //     validations: {
    //         presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
    //         format: {
    //             message: VALIDATION_MESSAGES.INVALID,
    //             pattern: REGEX_PATTERNS.IFSC_CODE
    //         }
    //     }
    // },
    panNumber: {
        type: "input",
        label: "PAN Number",
        isRequired: true,
        toUpperCase: true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            format: {
                message: VALIDATION_MESSAGES.INVALID,
                pattern: REGEX_PATTERNS.PAN
            }
        }
    },
    nameOnPan: {
        type: "input",
        label: "Name on PAN",
        isRequired: true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            format: {
                message: VALIDATION_MESSAGES.INVALID,
                pattern: REGEX_PATTERNS.ONLY_ALPHA_SPACES
            }
        }
    },
    dateOnPan: {
        type: "date",
        label: "Date on PAN (dd/mm/yyyy)",
        isRequired: true,
        format: "dd/MM/yyyy",
        isStringDate: true,
        maxDate: new Date(),
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            format: {
                message: VALIDATION_MESSAGES.INVALID,
                pattern: REGEX_PATTERNS.DATE
            }
        }
    },
    addressProof: {
        type: "select",
        label: "Address Proof",
        isRequired: true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    },
    addressProofCopy: {
        type: "upload",
        label: "Upload Address Proof (PNG & JPEG)",
        isRequired: true,
        onlyImage: true,
        showImageData: true
    }
};

export default FIELDS;